import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import {
  InvoiceSyncErrorReasonDTO,
  InvoiceSyncErrorReasonResponse,
} from '../types/dto/invoice-sync-error-reason.dto';
import {
  InvoiceSyncOperationDTO,
  InvoiceSyncOperationResponse,
} from '../types/dto/invoice-sync-operation.dto';
import { InvoiceSyncErrorResponse } from '../types/dto/response/invoice-sync-error.response';
import { InvoiceSyncError, InvoiceSyncErrorReason, InvoiceSyncOperation } from '../types/invoice';

export const mapInvoiceSyncOperationFromDTO = (
  operation: InvoiceSyncOperationResponse | null | undefined
): InvoiceSyncOperation | null => {
  switch (operation) {
    case InvoiceSyncOperationDTO.CREATE:
      return InvoiceSyncOperation.Create;
    case InvoiceSyncOperationDTO.UPDATE:
      return InvoiceSyncOperation.Update;
    default:
      return null;
  }
};

export const mapInvoiceSyncErrorReasonFromDTO = (
  reason: InvoiceSyncErrorReasonResponse | null | undefined
): InvoiceSyncErrorReason | null => {
  switch (reason) {
    case InvoiceSyncErrorReasonDTO.PROJECT_NOT_AVAILABLE:
      return InvoiceSyncErrorReason.ProjectNotAvailable;
    case InvoiceSyncErrorReasonDTO.CUSTOMER_NOT_AVAILABLE:
      return InvoiceSyncErrorReason.CustomerNotAvailable;
    case InvoiceSyncErrorReasonDTO.PRODUCT_OR_SERVICE_NOT_AVAILABLE:
      return InvoiceSyncErrorReason.ProductOrServiceNotAvailable;
    case InvoiceSyncErrorReasonDTO.CUSTOMER_CURRENCY_MISMATCH:
      return InvoiceSyncErrorReason.CustomerCurrencyMismatch;
    case InvoiceSyncErrorReasonDTO.CURRENCY_NOT_ENABLED:
      return InvoiceSyncErrorReason.CurrencyNotEnabled;
    case InvoiceSyncErrorReasonDTO.ACCOUNTING_PERIOD_CLOSED:
      return InvoiceSyncErrorReason.AccountingPeriodClosed;
    case InvoiceSyncErrorReasonDTO.NEGATIVE_LINE_AMOUNT_NOT_ALLOWED:
      return InvoiceSyncErrorReason.NegativeLineAmountNotAllowed;
    case InvoiceSyncErrorReasonDTO.LINE_DESCRIPTION_TOO_LONG:
      return InvoiceSyncErrorReason.LineDescriptionTooLong;
    case InvoiceSyncErrorReasonDTO.PAYMENT_TERM_NOT_AVAILABLE:
      return InvoiceSyncErrorReason.PaymentTermNotAvailable;
    case InvoiceSyncErrorReasonDTO.TRANSACTION_DATE_NOT_ALLOWED:
      return InvoiceSyncErrorReason.TransactionDateNotAllowed;
    case InvoiceSyncErrorReasonDTO.LINE_VALUE_OUT_OF_RANGE:
      return InvoiceSyncErrorReason.LineValueOutOfRange;
    case InvoiceSyncErrorReasonDTO.DATA_REJECTED:
      return InvoiceSyncErrorReason.DataRejected;
    default:
      return null;
  }
};

export const mapInvoiceSyncErrorFromResponse = (
  response: InvoiceSyncErrorResponse | null | undefined
): InvoiceSyncError | null => {
  if (!response) {
    return null;
  }

  const provider =
    response.provider && response.provider !== IntegrationProviderDTO.UNKNOWN
      ? mapIntegrationProviderFromDTO(response.provider)
      : null;

  return {
    code: response.code,
    message: response.message,
    provider,
    details: response.details ?? null,
    reason: mapInvoiceSyncErrorReasonFromDTO(response.reason),
  };
};
